<template>
  <CHeader fixed light class="preika-header">
    <CToggler
      in-header
      class="d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="d-md-down-none"
      :class="{ 'preika-header__sidebar-toggle--closed': !sidebarOpened }"
      :title="sidebarToggleLabel"
      :aria-label="sidebarToggleLabel"
      @click="$store.commit('toggleSidebarDesktop')"
    />

    <CHeaderBrand class="mx-auto d-lg-none" to="/dashboard">
      <img
        src="/img/avatars/preika_black.png"
        :alt="productName"
      >
    </CHeaderBrand>

    <div class="preika-header__context d-md-down-none">
      <span class="preika-header__mark">
        <CIcon name="cil-grid"/>
      </span>
      <span class="preika-header__copy">
        <small class="preika-header__eyebrow">{{ productName }}</small>
        <strong class="preika-header__title">{{ currentPageTitle }}</strong>
      </span>
    </div>

    <CHeaderNav class="ml-auto mr-2">
      <div class="preika-header__quick-links d-md-down-none">
        <button
          type="button"
          class="preika-header__search-trigger"
          title="横断検索（Ctrl+K）"
          aria-label="横断検索を開く"
          @click="openCommandPalette"
        >
          <CIcon name="cil-magnifying-glass"/>
          <span>検索</span>
          <kbd>Ctrl K</kbd>
        </button>
        <CHeaderNavLink
          to="/submission_approval/report_list"
          class="preika-header__quick-link"
          title="自分の申請一覧"
          aria-label="自分の申請一覧"
        >
          <CIcon name="cil-inbox"/>
        </CHeaderNavLink>
        <CHeaderNavLink
          to="/submission_approval/submission_management"
          class="preika-header__quick-link"
          title="承認待ちの申請"
          aria-label="承認待ちの申請"
        >
          <CIcon name="cil-check-circle"/>
        </CHeaderNavLink>
      </div>
      <TheHeaderDropdownAccnt @logout-failed="showLogoutFailure"/>
    </CHeaderNav>

    <!--
      **ログアウトに失敗したことを、画面の上端に出す**（束23）。

      アカウントメニューの中に出すと、メニューを閉じたときに一緒に消える。
      閉じるまで残し、何度押しても1つだけにする。
    -->
    <div
      v-if="logoutNotice"
      class="preika-header__notice"
      role="alert"
    >
      <span>{{ logoutNotice }}</span>
      <button
        type="button"
        class="preika-header__notice-close"
        aria-label="エラー表示を閉じる"
        @click="logoutNotice = ''"
      >閉じる</button>
    </div>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import routePageTitle from '@/utils/routePageTitle'
import { PRODUCT_NAME } from '@/common/productName'

export default {
  name: 'TheHeader',

  components: {
    TheHeaderDropdownAccnt
  },

  data () {
    return {
      /* ログアウトに失敗したときの知らせ。閉じるまで出す。 */
      logoutNotice: ''
    }
  },

  computed: {
    /** 売るときの正式な表記。**1か所から取る。** */
    productName () {
      return PRODUCT_NAME
    },

    currentPageTitle () {
      return routePageTitle(this.$route)
    },

    sidebarOpened () {
      return [true, 'responsive'].includes(this.$store.state.sidebarShow)
    },

    sidebarToggleLabel () {
      return this.sidebarOpened
        ? 'メニューを閉じる'
        : 'メニューを開く'
    }
  },

  methods: {
    openCommandPalette () {
      window.dispatchEvent(new CustomEvent('preika:command-palette-open'))
    },

    showLogoutFailure (message) {
      this.logoutNotice = String(message || '')
    }
  }
}
</script>
